import colors from '@constants/colors';
import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

interface Props extends IconProps {
    variant?: 'line' | 'fill';
}

function InfoIcon({
    size = ICON_DEFAULT_SIZE, color, variant = 'line', ...rest
}: Props) {
    if (variant === 'fill') {
        return (
            <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                {...rest} >
                <circle cx="6" cy="6" r="6" fill={color ?? colors.primary}/>
                <path d="M4.68555 8.86133V8.02539H5.48633V5.77148H4.7207V4.93555H6.50977V8.02539H7.31445V8.86133H4.68555ZM5.98242 4.45508C5.80273 4.45508 5.64779 4.39128 5.51758 4.26367C5.38997 4.13346 5.32617 3.97591 5.32617 3.79102C5.32617 3.61133 5.38997 3.45768 5.51758 3.33008C5.64779 3.20247 5.80273 3.13867 5.98242 3.13867C6.16471 3.13867 6.31966 3.20247 6.44727 3.33008C6.57747 3.45768 6.64258 3.61133 6.64258 3.79102C6.64258 3.97591 6.57747 4.13346 6.44727 4.26367C6.31966 4.39128 6.16471 4.45508 5.98242 4.45508Z" fill="white"/>
            </svg>
        );
    }
    const lineColor = color ?? ICON_DEFAULT_COLOR;
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <circle cx="12" cy="12" r="8" stroke={lineColor} strokeWidth="2"/>
            <rect x="11" y="10" width="2" height="7" rx="1" fill={lineColor}/>
            <rect x="11" y="7" width="2" height="2" rx="1" fill={lineColor}/>
        </svg>
    );
}

export default InfoIcon;
